const lazyLoad = {
    imgsLazy: document.querySelectorAll('.jsLazy') as NodeListOf<HTMLElement>,
    imgsDoom: document.querySelectorAll('.jsDomLoaded') as NodeListOf<HTMLElement>,

    init() {
        this.addScroll();
        this.domLoaded();
    },
    isInView(el: HTMLElement) {
        const rect = el.getBoundingClientRect();
        return   rect.top  <= window.innerHeight;      
    },
    addImg(item: HTMLElement) {

        if (item.dataset.img && item.dataset.loaded === 'false') {
            item.style.backgroundImage = `url(${item.dataset.img})`;
            item.dataset.loaded = 'true';
        }
    },
    addScroll() {
      
        window.addEventListener('scroll', () => {
            this.imgsLazy.forEach(item => {
                if (this.isInView(item)) {
                  
                    this.addImg(item);
                }
            })
        },{passive: true})
    },
    domLoaded() {
        window.addEventListener('load', () => {
            this.imgsDoom.forEach(item => {
                this.addImg(item);
            })
        })
    }
    // isInView() {       

    //     const observer = new IntersectionObserver(([elements]) => {
    //         let inView =  elements.isIntersecting;
    //         let el = elements.target as HTMLElement;
    //         console.log(el)
    //         if(inView){

    //             if(el.dataset.img && el.dataset.loaded === 'false') {

    //                 el.style.backgroundImage = `url(${el.dataset.img})`;
    //                 el.dataset.loaded = 'true';
    //                 observer.unobserve(el);
    //             }

    //         }

    //       });

    //     this.imgs.forEach(item=>{
    //         console.log(item)
    //         observer.observe(item);
    //     })

    // },


}

export default lazyLoad;